import { ADMIN_PROTECTED_ROUTES } from "../../routes";
export const handleViewDetails = (id: string,navigate:any) => {
    navigate(ADMIN_PROTECTED_ROUTES.TENANT_DETAILS.replace(":id", id));
  };